import type ApiProductList from "@/pages/apply/components/ApiProductList";

export const STORAGE_KEYS = {
  TOKEN: 'token',
  CHANNEL_CODE: 'channelCode',
  AD_CHANNEL_CODE: 'adChannelCode', // channelCode 别名，兼容用
  CO_OPERATION_TYPE: 'cooperationType',
  
  INCOME_DATA: 'INCOME_DATA', // 授信信息
  INCOME_DICT: 'INCOME_DICT', // 授信相关字典
  


  USERINFO:'USERINFO',
  USER_MARK_CACHE_KEY: 'USER_MARK_CACHE', // 用户匿名标识

  API_PRODUCT_LIST_QUERY: 'API_PRODUCT_LIST_QUERY', // 缓存的API产品列表请求参数
  
}


export const RESPONSE_CODE = {
  SUCCESS: 200, // 接口调用成功
  TOKEN_OVERDUE: 401, // token 失效，登录过期
}